"use client";

import ReviewsSectionCommon from "@/components/common/ReviewsSection";
import { reviewSets } from "@/lib/reviewsData";
import type { AllRatingsData } from "@/lib/fetchRatings";

interface ReviewsSectionProps {
  ratings?: AllRatingsData;
  sectionSpacingClassName?: string;
  sectionBackgroundClassName?: string;
  showSectionHeading?: boolean;
}

export default function ReviewsSection({
  ratings,
  sectionSpacingClassName,
  sectionBackgroundClassName,
  showSectionHeading = true,
}: ReviewsSectionProps = {}) {
  return (
    <ReviewsSectionCommon
      title="What Our Members Say"
      showSectionHeading={showSectionHeading}
      reviewSets={reviewSets}
      cardBorderClassName="border-2 border-border"
      cardContentPadding="pt-6 pb-6 px-4"
      cardAnimationClassName=""
      sectionTransitionClassName="transition-opacity duration-700 will-change-[opacity]"
      sectionVisibleClassName="opacity-100"
      useVisibilityStyle={true}
      ratings={ratings}
      sectionSpacingClassName={sectionSpacingClassName}
      sectionBackgroundClassName={sectionBackgroundClassName}
    />
  );
}
